module.exports = __webpack_public_path__ + "static/img/08.b6ed0f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuoyue/08.jpg
// module id = HnoB
// module chunks = 2